import { createStyles, Theme } from '@material-ui/core';

const styles = ({
  palette: {
    primary,
    common: { white },
  },
}: Theme) =>
  createStyles({
    content: {
      backgroundColor: white,
      width: '100%',
      height: '100vh',
      marginLeft: 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& > * ': {
        transform: 'scale(1.5)',
      },
      '& > svg rect, svg path': {
        fill: primary.main,
      },
    },
  });

export default styles;
